import React from 'react';
import { ConfirmDialog } from './ConfirmDialog';

interface HelpDialogProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onClose: () => void;
  confirmText?: string;
  variant?: 'danger' | 'warning' | 'info';
}

export const HelpDialog: React.FC<HelpDialogProps> = ({
  isOpen,
  title,
  message,
  onClose,
  confirmText = '知道了',
  variant = 'info',
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText=""
      onConfirm={onClose}
      onCancel={onClose}
      variant={variant}
    />
  );
};

export default HelpDialog;


